import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useAppSelector } from 'reduxStore/hooks';

function DocumentVerifier() {
  const [patientDocumentRemarks, setPatientDocumentRemarks] = useState('');
  const searchPatientDetailsByDocumentIdResponse = useAppSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state: any) => state.searchPatientDetailsByDocumentIdRes,
  );
  const [selectedStatusValue, setSelectedStatusValue] = useState<any>(null);
  const updateSelectedStatus = (passedVal: any) => {
    setSelectedStatusValue(passedVal);
  };
  const statusList = [
    {
      label: 'Mark as Failed',
      value: 1,
    },
    {
      label: 'Mark as Incomplete',
      value: 1,
    },
    {
      label: 'Mark as Verified',
      value: 1,
    },
  ];
  //   const [selectedStatusValue, setSelectedStatusValue] = useState<any>(null);
  //   const updateSelectedStatus = (passedVal: any) => {
  //     setSelectedStatusValue(passedVal);
  //   };
  return (
    <Card>
      <CardContent>
        <Grid container direction='row' justifyContent='space-between' alignItems='stretch' pt={2}>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={12}
            xl={12}
            sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0, lg: 2, xl: 2 } }}
          >
            <TextField
              label='Remarks'
              placeholder='Enter Remarks'
              variant='outlined'
              size='small'
              value={patientDocumentRemarks}
              onChange={(event) => setPatientDocumentRemarks(event.target.value)}
              disabled={searchPatientDetailsByDocumentIdResponse?.loading}
              // onChange={(event) => setPatientMRN(event.target.value)}
              fullWidth
              multiline={true}
              maxRows={6}
              minRows={4}
              sx={{ mb: 2 }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={12}
            xl={12}
            sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0, lg: 2, xl: 2 } }}
          >
            <Grid
              container
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              spacing={2}
            >
              <Grid item xs={12} sm={12} md={11} lg={11} xl={11}>
                <Autocomplete
                  fullWidth
                  size='small'
                  // disabled={setPreferenceValueRes?.loading}
                  value={selectedStatusValue}
                  options={statusList}
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  onChange={(_event: any, newValue: any) => {
                    updateSelectedStatus(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label='Select Status' variant='outlined' fullWidth />
                  )}
                  getOptionLabel={(option) => `${option.label}`}
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  isOptionEqualToValue={(option: any, value) => option.id === value.value}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                <Button variant='contained' color='primary' sx={{ float: 'right' }}>
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default DocumentVerifier;
